var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.33533C21 4.82533 20.02 5.02433 19 5.32533C17.879 4.06033 16.217 3.99033 14.62 4.58833C13.023 5.18633 11.977 6.64833 12 8.32533V9.32533C8.755 9.40833 5.865 7.93033 4 5.32533C4 5.32533 -0.182 12.7583 8 16.3253C6.128 17.5723 4.261 18.4133 2 18.3253C5.308 20.1283 8.913 20.7483 12.034 19.8423C15.614 18.8023 18.556 16.1193 19.685 12.1003C20.0218 10.878 20.189 9.61519 20.182 8.34733C20.182 8.09833 21.692 5.57533 22 4.33433V4.33533Z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.adea8559a28accf54d28e23f1e2666bb.svg";
export { ForwardRef as ReactComponent };